exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow[data-v-e70298a4]{border:solid black;border-width:0 1px 1px 0;display:inline-block;padding:5px;right:20px;bottom:22px}.right[data-v-e70298a4]{transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.left[data-v-e70298a4]{transform:rotate(135deg);-webkit-transform:rotate(135deg)}button i[data-v-e70298a4]{color:#e0e0e0;font-size:28px;line-height:24px}button:hover i[data-v-e70298a4],button:focus i[data-v-e70298a4]{color:#707070}\n", ""]);

// exports
